//"use client";

import React, { useEffect, useState, useRef } from 'react';
//import parse from 'html-react-parser';

export default function UseAppModal({open}) {
  console.log('UseAppModal', open);
  const dialogRef = useRef(null);
  const [show, setShow] = useState(open);

  useEffect(() => {
    //console.log('HelpModal UE');
    if (show) {
      dialogRef.current.showModal();

      const hd = document.querySelector("dialog");
      //console.log('hd', hd);
      hd.addEventListener("close", (event) => {
        console.log('UseAppModal close event');
        }
      );
    }

    return () => {
      //console.log('HelpModal return');
      //resetHelpState();
    }
  }, [show])

  function clicked() {
    console.log('clicked');
    // const hd = document.querySelector("dialog");
    // hd.close();
    // setShow(false);
  }

  function close() {
    console.log('close');
    localStorage.setItem('closeApp', 'true');
    window.location.href = '/';
  }

  return (
    <dialog 
      onClick={()=>clicked()}
      className='w-[90vw] h-[80vh] pb-4 px-4 border-2 rounded-md border-black bg-red-200' 
      ref={dialogRef}
      >
      <div className='w-full flex flex-col justify-normal text-2xl font-semibold'>
        <p className='w-full text-2xl font-bold text-center'>
          The app is installed
        </p>
        <p>
          The app has been installed and should be started using the app icon.
        </p>
        <p>
          Close this window and open the app by clicking the app icon.
        </p>
        <div className='w-full flex justify-center mt-20'>
          <button 
            className='plainBtn bg-red-600 text-white' 
            onClick={()=>close()}
            >
              Close
            </button>
        </div>
      </div>
    </dialog>
  )
}

 